export default [{
  mainButton: {
    name: 'forecast-view',
    label: 'Сравнительный',
    tooltip: 'Сравнительный вид графиков',
    goTo: '?forecastChartType=spline'
  },
  hideSeparator: true
}, {
  mainButton: {
    name: 'forecast-view-filled',
    label: 'Накопительный',
    tooltip: 'Накопительный вид графиков',
    goTo: '?forecastChartType=area-spline'
  }
}, {
  mainButton: {
    name: 'uploadDownload',
    label: 'Загрузка /<br>Выгрузка',
    tooltip: 'Загрузка и выгрузка данных',
    menu: [{
      name: 'upload',
      label: 'загрузить нагрузку',
      goTo: '?modal=ForecastUpload'
    }, {
      name: 'download',
      label: 'скачать "Потребность в сотрудниках"',
      goTo: '?modal=ForecastDownload'
    }]
  }
}];